const bannerImages = import.meta.glob("/src/assets/banners/*", {
  eager: true,
  query: "?url",
  import: "default",
});
const carBrandImages = import.meta.glob(
  "/src/assets/banners/Car Brand Tiles/*",
  { eager: true, query: "?url", import: "default" }
);
const logoImages = import.meta.glob("/src/assets/banners/Logos/*", {
  eager: true,
  query: "?url",
  import: "default",
});

export const getBannerImageUrl = (filename: string) => {
  const path = `/src/assets/banners/${filename}`;
  return bannerImages[path] as string;
};

export const getCarBrandImageUrl = (filename: string) => {
  const path = `/src/assets/banners/Car Brand Tiles/${filename}`;
  return carBrandImages[path] as string;
};

export const getLogoImageUrl = (filename: string) => {
  const path = `/src/assets/banners/Logos/${filename}`;
  return logoImages[path] as string;
};
